module.exports = __webpack_public_path__ + "img/run.36f0e6ee.svg";